import {createAsyncThunk} from '@reduxjs/toolkit'

import {qs} from '@shared/helpers/queryString'

import {FAMILY_MEMBERSHIP_SETTING_URL} from '@web/core/urls'
import {changeBrowserLocation} from '@web/helpers/browser'

import {NavigationResult, LocationChangeHistoryParam, ThunkApi} from '../interfaces'

/**
 * 패밀리 멤버십 설정 페이지로 이동
 */
const navigateToFamilyMembershipSetting = createAsyncThunk<
    NavigationResult,
    (LocationChangeHistoryParam & {from?: 'join'; preserveCircularHistory?: boolean}) | void,
    ThunkApi
>('navigateTo/familyMembershipSetting', async (args) => {
    const {historyType = 'PUSH', from = '', preserveCircularHistory = false} = args ?? {}
    const url = from
        ? qs.stringifyUrl({url: FAMILY_MEMBERSHIP_SETTING_URL, query: {from}})
        : FAMILY_MEMBERSHIP_SETTING_URL

    changeBrowserLocation({url, type: historyType, preserveCircularHistory})
    // page 이동은 그 자체로 추가동작 없이 resolve 된다
    return Promise.resolve()
})

export default navigateToFamilyMembershipSetting
